import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import {
  HealCourseEnrolmentsForm,
  isHealCourseEnrolmentsFormValid,
} from "./heal-course-enrolments-form";
import ScriptStartSuccessDialog from "./shared/script-start-success-dialog";

export const HealCourseEnrolmentsDialog: React.FC = () => {
  const {
    healCourseEnrolmentsDialogOpen,
    setHealCourseEnrolmentsDialogOpen,
    resetHealCourseEnrolmentsFormState,
    handleStartHealCourseEnrolments,
    healCourseEnrolmentsFormState,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Heal Course Enrolments"
      open={healCourseEnrolmentsDialogOpen}
      setOpen={setHealCourseEnrolmentsDialogOpen}
      onConfirm={async () => {
        await handleStartHealCourseEnrolments();
      }}
      disabled={!isHealCourseEnrolmentsFormValid(healCourseEnrolmentsFormState)}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start Script"
      onCancel={() => {
        resetHealCourseEnrolmentsFormState();
        setHealCourseEnrolmentsDialogOpen(false);
      }}
    >
      <HealCourseEnrolmentsForm />
    </ConfirmDialog>
  );
};

export const HealCourseEnrolmentsDialogWrapper: React.FC = () => {
  const {
    healCourseEnrolmentsSuccessDialogOpen,
    setHealCourseEnrolmentsSuccessDialogOpen,
    healCourseEnrolmentsBackgroundJobId,
  } = useTrainingMigrationContext();

  return (
    <>
      <HealCourseEnrolmentsDialog />
      <ScriptStartSuccessDialog
        open={healCourseEnrolmentsSuccessDialogOpen}
        onClose={() => setHealCourseEnrolmentsSuccessDialogOpen(false)}
        backgroundJobId={healCourseEnrolmentsBackgroundJobId}
        scriptName="Heal Course Enrolments Script"
      />
    </>
  );
};
